/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".producto-equivalencia__modal-add-edit__sku_input[_ngcontent-%COMP%]{max-width:160px}.producto-equivalencia__modal-add-edit__info-warning[_ngcontent-%COMP%]{color:red}.disabledContent[_ngcontent-%COMP%]{pointer-events:none;opacity:.8}"];
export { styles as styles };
